import React from 'react';
import { faDollarSign, faMagnifyingGlass, faHouse } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';

const StandForYou = () => {

    return (
        <div>
            <div className='container  mt-4'>
                <div className='row'>
                    <div className='col-lg-6 pe-5'>
                        <p className="red-clr f-16 lh-1 mt-5 mb-2 f-pop-bold">
                            Online Booking
                        </p>
                        <p className="blu-clr-book f-28 lh-1 mb-3 f-pop-med text-dark">
                            Book Your Ride in 1-Minute
                        </p>
                        <p className='f-14 f-pop-med'>
                            All the time, and every day of the week, we are here to assist you. Whether travelling alone or in a group, we offer personal and cheap taxi to Stansted airport from London and other major cities. Our process of hiring Taxi to Stansted Airport is simple. We provide you with an instant online quote for your journey after you fill out the contact us or place an inquiry with us. All our employees devote themselves to making your reservation go as smoothly as possible from the moment you contact us to the moment you ride with us. We provide an air conditioning car specifically arranged for the number of people and the amount of luggage you specify. In addition, all our drivers are appropriately vetted, DBS checked and licensed to provide you with safe and outstanding services.
                        </p>

                        {/* <ul className='ul_pad_zero'>
                            <li className='ul_tick_round f-pop-med'>Curabitur placerat cursus nisi nec pharetra. Proin quis tortor </li>
                            <li className='ul_tick_round f-pop-med'>Curabitur placerat cursus nisi nec pharetra. Proin quis tortor </li>
                            <li className='ul_tick_round f-pop-med'>Curabitur placerat cursus nisi nec pharetra. Proin quis tortor </li>
                        </ul> */}
                        <Link to="/stanstedairport">
                            <button className='btn btn-danger res-mrgn-set-standfor red-clr-btn p-bt-cus mt-4 f-14 f-pop-med'> Read more </button>
                        </Link>
                    </div>
                    <div className='col-lg-6'>
                        <div className='img_airport_home'>

                        </div>
                    </div>
                    <div className='col-lg-4 my-5 px-4'>
                        <div className='blue_box_home p-3 hvr_clr_blk_standforu pt-4'>
                            <FontAwesomeIcon className='font-ico-down-sec mb-3' icon={faDollarSign} />
                            <p className='f-20 mb-3 f-pop-med'>Affordable Rates </p>
                            <p className='f-13 f-pop-med clr-standforu-blk'>
                                We charge a minimal fee and offer excellent services.
                            </p>
                        </div>
                    </div>
                    <div className='col-lg-4 my-5 px-4'>
                        <div className='blue_box_home p-3 hvr_clr_blk_standforu pt-4'>
                            <FontAwesomeIcon className='font-ico-down-sec mb-3 ' icon={faMagnifyingGlass} />
                            <p className='f-25 mb-3 f-pop-med'>Easy Booking </p>
                            <p className='f-14  f-pop-med clr-standforu-blk'>
                                Our ride-booking method is as easy as 1-2-3.
                            </p>
                        </div>
                    </div>
                    <div className='col-lg-4 my-5 px-4'>
                        <div className='blue_box_home p-3 hvr_clr_blk_standforu pt-4'>
                            <FontAwesomeIcon className='font-ico-down-sec  mb-3' icon={faHouse} />
                            <p className='f-20 mb-3 f-pop-med'>Pick and Drop </p>
                            <p className='f-14 f-pop-med clr-standforu-blk'>
                                We are with you every step of the way.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default StandForYou;